import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AlertController } from '@ionic/angular/standalone';
import { AuthService } from '../services/auth';

/**
 * Blocks demo (anonymous) users from accessing private routes.
 * Shows a prompt inviting them to register.
 */
export const demoGuard: CanActivateFn = async () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const alertCtrl = inject(AlertController);

  if (!auth.isDemoSession) return true;

  const alert = await alertCtrl.create({
    cssClass: 'demo-upgrade-alert',
    header: 'Crea tu cuenta',
    message: 'Esta sección requiere una cuenta. Regístrate gratis para acceder a tu perfil, amigos y más.',
    buttons: [
      {
        text: 'Ahora no',
        role: 'cancel',
      },
      {
        text: 'Registrarme',
        handler: () => router.navigate(['/pages/auth/register']),
      },
    ],
  });
  await alert.present();

  return false;
};
